var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.alert.show)?_c('alert',{attrs:{"buttons":_vm.alert.buttons,"icon":_vm.alert.icon,"iconColor":_vm.alert.iconColor,"subtitle":_vm.alert.subtitle,"title":_vm.alert.title}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }